import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { SeFeButtonModule } from 'se-fe-button'

import { AlreadyHaveAccountComponent } from './already-have-account/already-have-account.component'

@NgModule({
  declarations: [AlreadyHaveAccountComponent],
  exports: [AlreadyHaveAccountComponent],
  imports: [
    CommonModule,
    FormsModule,
    SeFeButtonModule,
  ],
})
export class SeHouseholdSetupFeatureAlreadyHaveAccountModule {}
